const actions = {
  PROJECT_ADD_BEGIN: 'PROJECT_ADD_BEGIN',
  PROJECT_ADD_SUCCESS: 'PROJECT_ADD_SUCCESS',
  PROJECT_ADD_ERR: 'PROJECT_ADD_ERR',

  PROJECT_DELETE_BEGIN: 'PROJECT_DELETE_BEGIN',
  PROJECT_DELETE_SUCCESS: 'PROJECT_DELETE_SUCCESS',
  PROJECT_DELETE_ERR: 'PROJECT_DELETE_ERR',

  PROJECT_READ_BEGIN: 'PROJECT_READ_BEGIN',
  PROJECT_READ_SUCCESS: 'PROJECT_READ_SUCCESS',
  PROJECT_READ_ERR: 'PROJECT_READ_ERR',

  PROJECT_UPDATE_BEGIN: 'PROJECT_UPDATE_BEGIN',
  PROJECT_UPDATE_SUCCESS: 'PROJECT_UPDATE_SUCCESS',
  PROJECT_UPDATE_ERR: 'PROJECT_UPDATE_ERR',

  projectAddBegin: () => {
    return {
      type: actions.PROJECT_ADD_BEGIN,
    };
  },

  projectAddSuccess: (data) => {
    return {
      type: actions.PROJECT_ADD_SUCCESS,
      data,
    };
  },

  projectAddErr: (err) => {
    return {
      type: actions.PROJECT_ADD_ERR,
      err,
    };
  },

  projectDeleteBegin: () => {
    return {
      type: actions.PROJECT_DELETE_BEGIN,
    };
  },

  projectDeleteSuccess: (data) => {
    return {
      type: actions.PROJECT_DELETE_SUCCESS,
      data,
    };
  },

  projectDeleteErr: (err) => {
    return {
      type: actions.PROJECT_DELETE_ERR,
      err,
    };
  },

  projectReadBegin: () => {
    return {
      type: actions.PROJECT_READ_BEGIN,
    };
  },

  projectReadSuccess: (data) => {
    return {
      type: actions.PROJECT_READ_SUCCESS,
      data,
    };
  },

  projectReadErr: (err) => {
    return {
      type: actions.PROJECT_READ_ERR,
      err,
    };
  },

  projectUpdateBegin: () => {
    return {
      type: actions.PROJECT_UPDATE_BEGIN,
    };
  },

  projectUpdateSuccess: (data) => {
    return {
      type: actions.PROJECT_UPDATE_SUCCESS,
      data,
    };
  },

  projectUpdateErr: (err) => {
    return {
      type: actions.PROJECT_UPDATE_ERR,
      err,
    };
  },
      
};

export default actions;
